import { Formik, Form, Field, ErrorMessage } from "formik";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import {
  getCurrentUser,
  insertRoomRatePlan,
  updateRoomRatePlan,
} from "../../api-config/config";
import "../ReservationForm/BookingForm.css";

const NewRoomRatePlanType = (props: any) => {
  const {
    handleClose,
    onRoomTypeAdded,
    roomTypeData,
    roomTypes,
    onSuccess,
  } = props;

  const loggedUser = getCurrentUser();
  const isEdit = Boolean(roomTypeData?.rate_plan_id);

  const defaultValues = {
    room_type: roomTypeData?.roomtype || "",
    planName: roomTypeData?.planname || "",
    included: roomTypeData?.included || "",
    rate_amount: roomTypeData?.amount || "",
    description: roomTypeData?.description || "",
  };

  const validationSchema = Yup.object({
    room_type: Yup.string().required("Room Type is required"),
    planName: Yup.string().required("Plan Name is required"),
    included: Yup.string().required("Included is required"),
    rate_amount: Yup.number().required("Amount is required"),
  });

  const getRoomTypeId = (name: string) => {
    const match = roomTypes.find(
      (r: any) =>
        r.room_type_name.replace(/\s/g, "").toLowerCase() ===
        name.replace(/\s/g, "").toLowerCase()
    );
    return match?.id;
  };

  const handleSubmit = (values: any) => {
    const room_type_id = getRoomTypeId(values.room_type);

    if (!room_type_id) {
      onSuccess?.("Invalid Room Type selected");
      return;
    }

    const api = isEdit
      ? updateRoomRatePlan(
          values.planName,
          values.included,
          values.description,
          Number(values.rate_amount),
          room_type_id,
          loggedUser?.hotel_code,
          roomTypeData.rate_plan_id
        )
      : insertRoomRatePlan(
          values.planName,
          values.included,
          values.description,
          Number(values.rate_amount),
          room_type_id,
          loggedUser?.hotel_code
        );

    api.then((res: any) => {
      if (res?.status_message === "failed") {
        onSuccess?.(res.message || "Something went wrong");
        return;
      }

      const message = isEdit
        ? "Rate plan updated successfully"
        : "Rate plan added successfully";

      onSuccess?.(message);
      onRoomTypeAdded();
      handleClose();
    });
  };

  return (
    <div className="booking-form-wrapper">
      <Formik
        initialValues={defaultValues}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form className="grid lg:grid-cols-1 p-8">
          {/* Room Type */}
          <div className="form-group">
            <label className="pb-2">
              Room Type <span className="text-red-600">*</span>
            </label>
            <Field as="select" name="room_type">
              <option value="">Select</option>
              {roomTypes?.map((room: any, i: number) => (
                <option key={i} value={room.room_type_name}>
                  {room.room_type_name}
                </option>
              ))}
            </Field>
            <ErrorMessage name="room_type" component="div" className="text-red-600 text-sm mt-1" />
          </div>

          {/* Plan Name + Included */}
          <div className="grid gap-4 lg:grid-cols-2">
            <div className="form-group">
              <label className="py-2">
                Plan Name <span className="text-red-600">*</span>
              </label>
              <Field as="select" name="planName">
                <option value="">Select</option>
                <option value="EP">EP</option>
                <option value="CP">CP</option>
                <option value="MAP">MAP</option>
                <option value="AP">AP</option>
              </Field>
              <ErrorMessage name="planName" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="form-group">
              <label className="py-2">
                Included <span className="text-red-600">*</span>
              </label>
              <Field as="select" name="included">
                <option value="">Select</option>
                <option value="Breakfast">Breakfast</option>
                <option value="Breakfast + 1 meal">Breakfast + 1 meal</option>
                <option value="Breakfast + 2 meal">Breakfast + 2 meal</option>
                <option value="Room Only">Room Only</option>
              </Field>
              <ErrorMessage name="included" component="div" className="text-red-600 text-sm mt-1" />
            </div>
          </div>

          {/* Amount + Description */}
          <div className="grid gap-4 lg:grid-cols-2">
            <div className="form-group">
              <label className="py-2">
                Extra Meal Price <span className="text-red-600">*</span>
              </label>
              <Field
                name="rate_amount"
                type="number"
                className="con-field"
                placeholder="Enter extra meal price"
              />
              <ErrorMessage name="rate_amount" component="div" className="text-red-600 text-sm mt-1" />
            </div>

            <div className="form-group">
              <label className="py-2">Description</label>
              <Field
                name="description"
                type="text"
                className="con-field"
                placeholder="Enter description"
              />
            </div>
          </div>

          {/* Buttons */}
          <div className="form-actions pt-4">
            <button type="button" onClick={handleClose} className="bg-sky-300">
              Cancel
            </button>
            <button type="submit" className="bg-sky-300">
              {isEdit ? "Update" : "Save"}
            </button>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default NewRoomRatePlanType;